import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    try {
      if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
        const initialIsMobile = typeof window !== 'undefined' ? window.innerWidth < MOBILE_BREAKPOINT : true;
        setIsMobile(initialIsMobile);
        return;
      }

      const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
      const onChange = () => {
        const newIsMobile = window.innerWidth < MOBILE_BREAKPOINT;
        console.log('Mobile state changed:', newIsMobile, 'width:', window.innerWidth);
        setIsMobile(newIsMobile);
      };

      // Safari/iOS fallback
      if (typeof mql.addEventListener === 'function') {
        mql.addEventListener('change', onChange);
      } else if (typeof (mql as any).addListener === 'function') {
        (mql as any).addListener(onChange);
      }

      // Initial check
      const initialIsMobile = window.innerWidth < MOBILE_BREAKPOINT;
      console.log('Initial mobile check:', initialIsMobile, 'width:', window.innerWidth);
      setIsMobile(initialIsMobile);

      return () => {
        if (typeof mql.removeEventListener === 'function') {
          mql.removeEventListener('change', onChange);
        } else if (typeof (mql as any).removeListener === 'function') {
          (mql as any).removeListener(onChange);
        }
      };
    } catch (e) {
      console.error('useIsMobile error, defaulting to mobile:', e);
      setIsMobile(true);
    }
  }, [])

  // Return true if we're still loading on a potentially mobile device, false otherwise
  return isMobile ?? false;
}
